import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
import { finalize } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core'
import { AuthService } from '../services/auth.service'

@Component({
    templateUrl: 'login.component.html',
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup
    error: boolean
    loading = false
    returnUrl: string
    hideInfo = false

    constructor(
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: [''],
            password: [''],
            language: [this.translate.currentLang],
        })

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/'
        this.hideInfo = this.route.snapshot.data['hideInfo']
    }

    onLanguageChange(value: string) {
        console.log(`Switching language to: ${value}`)
        this.translate.use(value)
    }

    get f() {
        return this.loginForm.controls
    }

    login() {
        this.error = false
        this.loading = true
        this.authService
            .login({
                username: this.f.username.value,
                password: this.f.password.value,
            })
            .pipe(
                finalize(() => {
                    console.log('finalize called')
                    this.loading = false
                })
            )
            .subscribe(
                (success) => {
                    if (success) {
                        this.router.navigateByUrl(this.returnUrl)
                        this.error = false
                    } else {
                        this.error = true
                    }
                },
                (err) => {
                    console.log('err called')
                    this.error = true
                },
                () => {
                    console.log('sth else called')
                }
            )
    }
}
